import * as React from "react";
import "./styles.css"

import {
  Box,
  TextField,
  Grid
} from "@mui/material";
import Button from "../../components/Button";
import Link from '@mui/material/Link';
import { useNavigate } from "react-router-dom";


function LandingScreen() {
  const navigate = useNavigate();
  const[data,setData]=React.useState({
    fname:"",
    email:"",
    lname:""
  })
  const[buttondisable,setButtondisable]=React.useState(true)


  const handleChange=(event)=>{
  const name = event.target.name;
  const value = event.target.value;
  setData(values => ({...values, [name]: value}))
  if(data.fname&&data.lname&&data.email&&event.target.value){
    setButtondisable(false)
  }
  else{
    setButtondisable(true)
  }
}



  return (

    <Grid  sx={{height:'100%' }} className='landing_conatiner'>
    <Box
          padding="8%"
          position='sticky'
          top='0'
          zIndex='1'
          sx={{
            borderRadius: "8px 8px",
            bgcolor: "#F2F2F2",
            opacity:'1',
            
          }}
        >
       <div style={{color:'#000000',fontSize:'20px',fontWeight:'bold',letterSpacing:0.12,position:'sticky',
            bottom:0}}>
          Tell us a bit about You !
          </div>
          
        </Box>
    <Grid padding="8%" pb={3} pt={3}  bgcolor="white" position='relative'>
        <Grid item sm={6} lg={12} pb={3} className="grid">
            <label htmlFor="name"  className="labelCls3">
                What is your first name ?
            </label>
            <TextField size="small"name="fname" placeholder="Name One" fullWidth value={data.fname} onChange={handleChange} className="textbox"/>
        </Grid>
        <Grid item sm={6} pb={3} lg={12} className="grid">
            <label htmlFor="name" className="labelCls3">
                What is your last name ?
            </label>
            <TextField size="small" placeholder="Name two"name="lname" fullWidth value={data.lname} onChange={handleChange}  />
        </Grid>
        <Grid item sm={6} pb={3} lg={12} className="grid">
            <label htmlFor="name" className="labelCls3">
              What is your email Email ID
            </label>
            <TextField size="small" name="email" placeholder="Name two" fullWidth value={data.email} onChange={handleChange} />
            <label htmlFor="name" className="labelCls3">
              We promise not to spam you!
              </label>
        </Grid>
      
       
        
    </Grid>
    <Grid display="flex" flexDirection="row" alignItems="center" justifyContent="center" bgcolor="#ffffff" padding="12px 20px 12px 20px"  width="100%" sx={{ position: 'fixed', bottom: 0, boxShadow:8 }}>
    <Button
                    color= {buttondisable?"grey":"green"}
                    opacity='1'
                    name="Save Details"
                    disabled={buttondisable}
                    onClick={() => {
                      navigate("/Job");
                    }}
                />
    </Grid>
</Grid>
     
  );
}
export default LandingScreen;